(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // Final-review fix C1/I3: the search-trigger listener below needs to close
  // both the mega menu and the drawer without restoring focus to their
  // triggers (search should end up focused instead). Both live in their own
  // IIFEs so their close functions aren't in scope there — stash references
  // on these module-scoped vars once each IIFE runs (both run synchronously,
  // before any user interaction, so they're assigned before the search
  // listener can ever fire).
  let ccCloseMega = null;
  let ccCloseDrawer = null;

  (function () {
    const megaTrigger = document.getElementById('cc-mega-menu-trigger');
    const megaPanel = document.getElementById('cc-mega-menu-panel');
    if (megaTrigger && megaPanel) {
      const isOpen = () => megaPanel.classList.contains('is-open');
      const closeMega = ({ restoreFocus = true } = {}) => {
        megaPanel.classList.remove('is-open');
        megaPanel.setAttribute('aria-hidden', 'true');
        megaTrigger.setAttribute('aria-expanded', 'false');
        if (restoreFocus) megaTrigger.focus();
      };
      ccCloseMega = closeMega;
      const openMega = () => {
        megaPanel.classList.add('is-open');
        megaPanel.setAttribute('aria-hidden', 'false');
        megaTrigger.setAttribute('aria-expanded', 'true');
        const selectedTab = megaPanel.querySelector('[aria-selected="true"]');
        if (selectedTab) selectedTab.focus();
      };
      megaTrigger.addEventListener('click', () => {
        if (!isOpen()) openMega();
        else closeMega();
      });
      document.addEventListener('click', (event) => {
        if (isOpen() && !megaPanel.contains(event.target) && !megaTrigger.contains(event.target)) closeMega();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && isOpen()) closeMega();
      });

      const tabs = megaPanel.querySelectorAll('[role="tab"]');
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => t.setAttribute('aria-selected', 'false'));
          tab.setAttribute('aria-selected', 'true');
          megaPanel.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
            panel.style.display = panel.id === tab.getAttribute('aria-controls') ? 'grid' : 'none';
          });
        });
      });
    }
  })();

  (function () {
    const drawerTrigger = document.getElementById('cc-drawer-trigger');
    const drawerPanel = document.getElementById('cc-drawer-panel');
    if (!drawerTrigger || !drawerPanel) return;

    // Final-review fix C1: options let callers close the drawer without
    // stealing focus back to the hamburger or unlocking the body scroll —
    // needed when the search modal is about to take over both of those.
    const closeDrawer = ({ restoreFocus = true, unlockBody = true } = {}) => {
      drawerPanel.hidden = true;
      drawerPanel.setAttribute('aria-hidden', 'true');
      drawerTrigger.setAttribute('aria-expanded', 'false');
      removeTrapFocus(restoreFocus ? drawerTrigger : null);
      if (unlockBody) document.body.classList.remove('overflow-hidden');
    };
    ccCloseDrawer = closeDrawer;
    // The panel drops down under the header bar (announcement bar and header stay visible), so its
    // top follows wherever the header sits when it opens, including the sticky state.
    const placeDrawer = () => {
      const bar = drawerTrigger.closest('header') || drawerTrigger.closest('.cc-header') || drawerTrigger.parentElement;
      const bottom = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
      drawerPanel.style.setProperty('--cc-drawer-top', bottom + 'px');
    };
    window.addEventListener('resize', () => { if (!drawerPanel.hidden) placeDrawer(); }, { passive: true });
    const openDrawer = () => {
      placeDrawer();
      drawerPanel.hidden = false;
      drawerPanel.setAttribute('aria-hidden', 'false');
      drawerTrigger.setAttribute('aria-expanded', 'true');
      trapFocus(drawerPanel, drawerPanel.querySelector('.cc-drawer__group-toggle, .cc-drawer__link'));
      document.body.classList.add('overflow-hidden');
    };
    // Shop groups: one open at a time, animated by the .is-open class (see CSS).
    drawerPanel.querySelectorAll('.cc-drawer__group-toggle').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const group = toggle.closest('.cc-drawer__group');
        const opening = !group.classList.contains('is-open');
        drawerPanel.querySelectorAll('.cc-drawer__group.is-open').forEach((other) => {
          other.classList.remove('is-open');
          other.querySelector('.cc-drawer__group-toggle').setAttribute('aria-expanded', 'false');
        });
        if (opening) {
          group.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
    drawerTrigger.addEventListener('click', () => {
      if (drawerPanel.hidden) openDrawer();
      else closeDrawer();
    });
    // The panel sits below the header, so the hamburger stays visible and is the close control
    // (with Escape and click-outside). The old in-panel close button was dropped with the redesign.
    document.addEventListener('click', (event) => {
      // Final-review fix C1: ignore clicks inside the search modal so this
      // click-outside handler can't double-close the drawer with default
      // (focus-stealing, body-unlocking) options right after the
      // capture-phase search-trigger listener below already closed it
      // silently for the modal's benefit.
      if (event.target.closest('#Details-SearchModal')) return;
      if (!drawerPanel.hidden && !drawerPanel.contains(event.target) && !drawerTrigger.contains(event.target)) closeDrawer();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || drawerPanel.hidden) return;
      if (event.target.closest('details[open]')) return;
      closeDrawer();
    });
  })();

  (function () {
    // Final-review fix C1/I3: DetailsModal (assets/details-modal.js) opens
    // the search overlay on the summary's bubble-phase `click` listener. If
    // the drawer (or a desktop dropdown/mega menu) is still open at that
    // moment, letting its own click-outside handler run afterwards tears
    // down what the modal just set up (removes trapFocus, unlocks the
    // body, moves focus back to the hamburger/mega trigger). A capture-
    // phase listener on document fires before ANY listener bound directly
    // to the summary (capture always precedes the target's own listeners),
    // so this always runs — and finishes closing everything else — before
    // DetailsModal.onSummaryClick ever executes.
    document.addEventListener(
      'click',
      (event) => {
        if (!event.target.closest('#cc-search-trigger')) return;

        if (ccCloseDrawer) ccCloseDrawer({ restoreFocus: false, unlockBody: false });

        // Same close() DetailsDisclosure/HeaderMenu (assets/details-disclosure.js)
        // already exposes, and the same pattern StickyHeader.closeMenuDisclosure()
        // above uses — idempotent, safe to call on every header-menu whether open or not.
        document.querySelectorAll('header-menu').forEach((disclosure) => disclosure.close());

        if (ccCloseMega) ccCloseMega({ restoreFocus: false });
      },
      true
    );
  })();

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
